// // // // // 




// // // // import React, { createContext, useContext, useState, useEffect } from 'react';
// // // // import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// // // // import axios from 'axios';
// // // // import io from 'socket.io-client';
// // // // import './App.css';
// // // // import Login from './pages/Login';
// // // // import ForgotPassword from './pages/ForgotPassword';
// // // // import ResetPassword from './pages/ResetPassword';
// // // // import Register from './pages/Register';
// // // // import AdminDashboard from './pages/AdminDashboard';
// // // // import UserDashboard from './pages/UserDashboard';
// // // // import InstitutionDashboard from './pages/InstitutionDashboard';
// // // // import InstitutionProfile from './pages/InstitutionProfile';
// // // // import UserProfile from './pages/UserProfile';
// // // // import Users from './pages/Users';
// // // // import Institutions from './pages/Institutions';
// // // // import Prestations from './pages/Prestations';
// // // // import UserPrestations from './pages/UserPrestations';
// // // // import Schedules from './pages/Schedules';
// // // // import Messages from './pages/Messages';
// // // // import Payslips from './pages/Payslips';
// // // // import Teams from './pages/Teams';
// // // // import Exchanges from './pages/Exchanges';
// // // // import Notifications from './pages/Notifications';
// // // // import { Toaster } from './components/ui/sonner';
// // // // import { toast } from 'sonner';
// // // // import Payrolls from './pages/Payrolls';
// // // // import InstitutionPayrolls from './pages/InstitutionPayrolls';



// // // // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // // // const API = `${BACKEND_URL}/api`;

// // // // // Auth Context
// // // // const AuthContext = createContext(null);

// // // // export const useAuth = () => useContext(AuthContext);

// // // // // Axios instance
// // // // const axiosInstance = axios.create({
// // // //   baseURL: API,
// // // // });

// // // // // Socket.io instance
// // // // let socket = null;

// // // // function App() {
// // // //   const [user, setUser] = useState(null);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [token, setToken] = useState(localStorage.getItem('token'));

// // // //   // Setup axios interceptor
// // // //   useEffect(() => {
// // // //     if (token) {
// // // //       axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// // // //     } else {
// // // //       delete axiosInstance.defaults.headers.common['Authorization'];
// // // //     }
// // // //   }, [token]);

// // // //   // Fetch current user
// // // //   useEffect(() => {
// // // //     const fetchUser = async () => {
// // // //       if (token) {
// // // //         try {
// // // //           const response = await axiosInstance.get('/auth/me');
// // // //           setUser(response.data);
          
// // // //           // Connect to socket.io
// // // //           if (!socket) {
// // // //             socket = io(BACKEND_URL);
// // // //             socket.emit('join', { user_id: response.data.id });
            
// // // //             // Listen for notifications
// // // //             socket.on('notification', (data) => {
// // // //               toast.info(data.message);
// // // //             });
            
// // // //             socket.on('new_message', (data) => {
// // // //               toast.info('New message received');
// // // //             });
// // // //           }
// // // //         } catch (error) {
// // // //           console.error('Failed to fetch user', error);
// // // //           localStorage.removeItem('token');
// // // //           setToken(null);
// // // //         }
// // // //       }
// // // //       setLoading(false);
// // // //     };
// // // //     fetchUser();
// // // //   }, [token]);

// // // //   const login = (newToken, userData) => {
// // // //     localStorage.setItem('token', newToken);
// // // //     setToken(newToken);
// // // //     setUser(userData);
// // // //   };

// // // //   const logout = () => {
// // // //     localStorage.removeItem('token');
// // // //     setToken(null);
// // // //     setUser(null);
// // // //     if (socket) {
// // // //       socket.disconnect();
// // // //       socket = null;
// // // //     }
// // // //   };

// // // //   const value = {
// // // //     user,
// // // //     token,
// // // //     login,
// // // //     logout,
// // // //     axiosInstance,
// // // //     socket
// // // //   };

// // // //   if (loading) {
// // // //     return (
// // // //       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-yellow-100">
// // // //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
// // // //       </div>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <AuthContext.Provider value={value}>
// // // //       <BrowserRouter>
// // // //         <div className="App">
// // // //           <Routes>
// // // //             <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
// // // //             <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            
// // // //             {/* <Route path="/dashboard" element={user ? (
// // // //               user.role === 'admin' ? <AdminDashboard /> : <UserDashboard />
// // // //             ) : <Navigate to="/login" />} /> */}
// // // //             <Route path="/dashboard" element={user ? (
// // // //               user.role === 'admin' ? <AdminDashboard /> :
// // // //               user.role === 'institution' ? <Navigate to="/institution-dashboard" /> :
// // // //               <UserDashboard />
// // // //             ) : <Navigate to="/login" />} />
// // // //             {/* <Route
// // // //               path="/profile"
// // // //               element={
// // // //                 user?.role === 'institution'
// // // //                   ? <InstitutionProfile />
// // // //                   : <Navigate to="/dashboard" />
// // // //               }
// // // //             /> */}
// // // //             {/* <Route
// // // //               path="/profile"
// // // //               element={
// // // //                 user?.role === 'institution' ? (
// // // //                   <InstitutionProfile />
// // // //                 ) : user?.role === 'nurse' || user?.role === 'caregiver' ? (
// // // //                   <UserProfile />
// // // //                 ) : (
// // // //                   <Navigate to="/dashboard" />
// // // //                 )
// // // //               }
// // // //             /> */}

// // // //             <Route
// // // //               path="/profile"
// // // //               element={
// // // //                 user?.role === 'institution' ? (
// // // //                   <InstitutionProfile />
// // // //                 ) : ['nurse', 'caregiver', 'admin'].includes(user?.role) ? (
// // // //                   <UserProfile />
// // // //                 ) : (
// // // //                   <Navigate to="/dashboard" />
// // // //                 )
// // // //               }
// // // //             />



            
// // // //             <Route path="/users" element={user?.role === 'admin' ? <Users /> : <Navigate to="/dashboard" />} />
// // // //             <Route
// // // //               path="/users/:id"
// // // //               element={user?.role === 'admin' ? <UserProfile /> : <Navigate to="/dashboard" />}
// // // //             />

// // // //             {/* <Route path="/institution-dashboard" element={<InstitutionDashboard />} /> */}
// // // //             <Route path="/institutions" element={user ? <Institutions /> : <Navigate to="/login" />} />
// // // //             <Route path="/reset-password" element={<ResetPassword />} />
// // // //             <Route path="/forgot-password" element={<ForgotPassword />} />
// // // //             <Route
// // // //               path="/institution-dashboard"
// // // //               element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />}
// // // //             />
// // // //             <Route
// // // //               path="/payrolls"
// // // //               element={user?.role === 'institution' ? <InstitutionPayrolls /> : <Navigate to="/dashboard" />}
// // // //             />

// // // //             {/* <Route path="/prestations" element={user ? <Prestations /> : <Navigate to="/login" />} /> */}
// // // //             <Route path="/schedules" element={user ? <Schedules /> : <Navigate to="/login" />} />
// // // //             <Route path="/messages" element={user ? <Messages /> : <Navigate to="/login" />} />
// // // //             <Route
// // // //               path="/prestations"
// // // //               element={
// // // //                 user
// // // //                   ? user.role === 'admin' || user.role === 'établissement de santé'
// // // //                     ? <Prestations />
// // // //                     : <UserPrestations />
// // // //                   : <Navigate to="/login" />
// // // //               }
// // // //             />

// // // //             <Route path="/mes-prestations" element={<UserPrestations />} />

// // // //             <Route path="/payslips" element={user ? <Payslips /> : <Navigate to="/login" />} />
// // // //             {/* <Route path="/payrolls" element={<Payrolls />} /> */}
// // // //             <Route path="/teams" element={user ? <Teams /> : <Navigate to="/login" />} />
// // // //             <Route path="/exchanges" element={user ? <Exchanges /> : <Navigate to="/login" />} />
// // // //             <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
            
// // // //             <Route path="/" element={<Navigate to="/dashboard" />} />
// // // //           </Routes>
// // // //           <Toaster position="top-right" richColors />
// // // //         </div>
// // // //       </BrowserRouter>
// // // //     </AuthContext.Provider>
// // // //   );
// // // // }

// // // // export default App;





// // // import React, { createContext, useContext, useState, useEffect } from 'react';
// // // import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// // // import axios from 'axios';
// // // import io from 'socket.io-client';
// // // import './App.css';
// // // import Login from './pages/Login';
// // // import ForgotPassword from './pages/ForgotPassword';
// // // import ResetPassword from './pages/ResetPassword';
// // // import Register from './pages/Register';
// // // import AdminDashboard from './pages/AdminDashboard';
// // // import UserDashboard from './pages/UserDashboard';
// // // import InstitutionDashboard from './pages/InstitutionDashboard';
// // // import InstitutionProfile from './pages/InstitutionProfile';
// // // import UserProfile from './pages/UserProfile';
// // // import Users from './pages/Users';
// // // import Institutions from './pages/Institutions';
// // // import Prestations from './pages/Prestations';
// // // import UserPrestations from './pages/UserPrestations';
// // // import Schedules from './pages/Schedules';
// // // import Messages from './pages/Messages';
// // // import Payslips from './pages/Payslips';
// // // import UserPayrolls from './pages/UserPayrolls';
// // // import Teams from './pages/Teams';
// // // import Exchanges from './pages/Exchanges';
// // // import Notifications from './pages/Notifications';
// // // import { Toaster } from './components/ui/sonner';
// // // import { toast } from 'sonner';
// // // import Payrolls from './pages/Payrolls';
// // // import InstitutionPayrolls from './pages/InstitutionPayrolls';


// // // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // // const API = `${BACKEND_URL}/api`;

// // // // Auth Context
// // // const AuthContext = createContext(null);

// // // export const useAuth = () => useContext(AuthContext);

// // // // Axios instance
// // // const axiosInstance = axios.create({
// // //   baseURL: API,
// // // });

// // // // Socket.io instance
// // // let socket = null;

// // // function App() {
// // //   const [user, setUser] = useState(null);
// // //   const [loading, setLoading] = useState(true);
// // //   const [token, setToken] = useState(localStorage.getItem('token'));

// // //   // Setup axios interceptor
// // //   useEffect(() => {
// // //     if (token) {
// // //       axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// // //     } else {
// // //       delete axiosInstance.defaults.headers.common['Authorization'];
// // //     }
// // //   }, [token]);

// // //   // Fetch current user
// // //   useEffect(() => {
// // //     const fetchUser = async () => {
// // //       if (token) {
// // //         try {
// // //           const response = await axiosInstance.get('/auth/me');
// // //           setUser(response.data);
          
// // //           // Connect to socket.io
// // //           if (!socket) {
// // //             socket = io(BACKEND_URL);
// // //             socket.emit('join', { user_id: response.data.id });
            
// // //             // Listen for notifications
// // //             socket.on('notification', (data) => {
// // //               toast.info(data.message);
// // //             });
            
// // //             socket.on('new_message', (data) => {
// // //               toast.info('New message received');
// // //             });
// // //           }
// // //         } catch (error) {
// // //           console.error('Failed to fetch user', error);
// // //           localStorage.removeItem('token');
// // //           setToken(null);
// // //         }
// // //       }
// // //       setLoading(false);
// // //     };
// // //     fetchUser();
// // //   }, [token]);

// // //   const login = (newToken, userData) => {
// // //     localStorage.setItem('token', newToken);
// // //     setToken(newToken);
// // //     setUser(userData);
// // //   };

// // //   const logout = () => {
// // //     localStorage.removeItem('token');
// // //     setToken(null);
// // //     setUser(null);
// // //     if (socket) {
// // //       socket.disconnect();
// // //       socket = null;
// // //     }
// // //   };

// // //   const value = {
// // //     user,
// // //     token,
// // //     login,
// // //     logout,
// // //     axiosInstance,
// // //     socket
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-yellow-100">
// // //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <AuthContext.Provider value={value}>
// // //       <BrowserRouter>
// // //         <div className="App">
// // //           <Routes>
// // //             <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
// // //             <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            
// // //             {/* <Route path="/dashboard" element={user ? (
// // //               user.role === 'admin' ? <AdminDashboard /> : <UserDashboard />
// // //             ) : <Navigate to="/login" />} /> */}
// // //             <Route path="/dashboard" element={user ? (
// // //               user.role === 'admin' ? <AdminDashboard /> :
// // //               user.role === 'institution' ? <Navigate to="/institution-dashboard" /> :
// // //               <UserDashboard />
// // //             ) : <Navigate to="/login" />} />
// // //             {/* <Route
// // //               path="/profile"
// // //               element={
// // //                 user?.role === 'institution'
// // //                   ? <InstitutionProfile />
// // //                   : <Navigate to="/dashboard" />
// // //               }
// // //             /> */}
// // //             {/* <Route
// // //               path="/profile"
// // //               element={
// // //                 user?.role === 'institution' ? (
// // //                   <InstitutionProfile />
// // //                 ) : user?.role === 'nurse' || user?.role === 'caregiver' ? (
// // //                   <UserProfile />
// // //                 ) : (
// // //                   <Navigate to="/dashboard" />
// // //                 )
// // //               }
// // //             /> */}

// // //             <Route
// // //               path="/profile"
// // //               element={
// // //                 user?.role === 'institution' ? (
// // //                   <InstitutionProfile />
// // //                 ) : ['nurse', 'caregiver', 'admin'].includes(user?.role) ? (
// // //                   <UserProfile />
// // //                 ) : (
// // //                   <Navigate to="/dashboard" />
// // //                 )
// // //               }
// // //             />



            
// // //             <Route path="/users" element={user?.role === 'admin' ? <Users /> : <Navigate to="/dashboard" />} />
// // //             <Route
// // //               path="/users/:id"
// // //               element={user?.role === 'admin' ? <UserProfile /> : <Navigate to="/dashboard" />}
// // //             />

// // //             {/* <Route path="/institution-dashboard" element={<InstitutionDashboard />} /> */}
// // //             <Route path="/institutions" element={user ? <Institutions /> : <Navigate to="/login" />} />
// // //             <Route path="/reset-password" element={<ResetPassword />} />
// // //             <Route path="/forgot-password" element={<ForgotPassword />} />
// // //             <Route
// // //               path="/institution-dashboard"
// // //               element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />}
// // //             />
// // //             <Route
// // //               path="/payrolls"
// // //               element={user?.role === 'institution' ? <InstitutionPayrolls /> : <Navigate to="/dashboard" />}
// // //             />


// // //             {/* <Route path="/prestations" element={user ? <Prestations /> : <Navigate to="/login" />} /> */}
// // //             <Route path="/schedules" element={user ? <Schedules /> : <Navigate to="/login" />} />
// // //             <Route path="/messages" element={user ? <Messages /> : <Navigate to="/login" />} />
// // //             <Route
// // //               path="/prestations"
// // //               element={
// // //                 user
// // //                   ? user.role === 'admin' || user.role === 'établissement de santé'
// // //                     ? <Prestations />
// // //                     : <UserPrestations />
// // //                   : <Navigate to="/login" />
// // //               }
// // //             />

// // //             <Route path="/mes-prestations" element={<UserPrestations />} />

// // //             {/* <Route path="/payslips" element={user ? <Payslips /> : <Navigate to="/login" />} /> */}
// // //             <Route
// // //               path="/user-payrolls"
// // //               element={user?.role === 'caregiver' || user?.role === 'nurse' ? <UserPayrolls /> : <Navigate to="/dashboard" />}
// // //             />
// // //             {/* <Route path="/payrolls" element={<Payrolls />} /> */}
            
            
          
// // //             <Route path="/teams" element={user ? <Teams /> : <Navigate to="/login" />} />
// // //             <Route path="/exchanges" element={user ? <Exchanges /> : <Navigate to="/login" />} />
// // //             <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
            
// // //             <Route path="/" element={<Navigate to="/dashboard" />} />
// // //           </Routes>
// // //           <Toaster position="top-right" richColors />
// // //         </div>
// // //       </BrowserRouter>
// // //     </AuthContext.Provider>
// // //   );
// // // }

// // // export default App;


// // import React, { createContext, useContext, useState, useEffect } from 'react';
// // import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// // import axios from 'axios';
// // import io from 'socket.io-client';
// // import './App.css';
// // import Login from './pages/Login';
// // import ForgotPassword from './pages/ForgotPassword';
// // import ResetPassword from './pages/ResetPassword';
// // import Register from './pages/Register';
// // import AdminDashboard from './pages/AdminDashboard';
// // import UserDashboard from './pages/UserDashboard';
// // import InstitutionDashboard from './pages/InstitutionDashboard';
// // import InstitutionProfile from './pages/InstitutionProfile';
// // import UserProfile from './pages/UserProfile';
// // import Users from './pages/Users';
// // import Institutions from './pages/Institutions';
// // import Prestations from './pages/Prestations';
// // import UserPrestations from './pages/UserPrestations';
// // import Schedules from './pages/Schedules';
// // import Messages from './pages/Messages';
// // import Payslips from './pages/Payslips';
// // import UserPayrolls from './pages/UserPayrolls';
// // import Teams from './pages/Teams';
// // import Exchanges from './pages/Exchanges';
// // import Notifications from './pages/Notifications';
// // import { Toaster } from './components/ui/sonner';
// // import { toast } from 'sonner';
// // import Payrolls from './pages/Payrolls';
// // import InstitutionPayrolls from './pages/InstitutionPayrolls';
// // import Tarifictions from './pages/Tarifications';


// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // const API = `${BACKEND_URL}/api`;

// // // Auth Context
// // const AuthContext = createContext(null);

// // export const useAuth = () => useContext(AuthContext);

// // // Axios instance
// // const axiosInstance = axios.create({
// //   baseURL: API,
// // });

// // // Socket.io instance
// // let socket = null;

// // function App() {
// //   const [user, setUser] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [token, setToken] = useState(localStorage.getItem('token'));

// //   // Setup axios interceptor
// //   useEffect(() => {
// //     if (token) {
// //       axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
// //     } else {
// //       delete axiosInstance.defaults.headers.common['Authorization'];
// //     }
// //   }, [token]);

// //   // Fetch current user
// //   useEffect(() => {
// //     const fetchUser = async () => {
// //       if (token) {
// //         try {
// //           const response = await axiosInstance.get('/auth/me');
// //           setUser(response.data);
          
// //           // Connect to socket.io
// //           if (!socket) {
// //             socket = io(BACKEND_URL);
// //             socket.emit('join', { user_id: response.data.id });
            
// //             // Listen for notifications
// //             socket.on('notification', (data) => {
// //               toast.info(data.message);
// //             });
            
// //             socket.on('new_message', (data) => {
// //               toast.info('New message received');
// //             });
// //           }
// //         } catch (error) {
// //           console.error('Failed to fetch user', error);
// //           localStorage.removeItem('token');
// //           setToken(null);
// //         }
// //       }
// //       setLoading(false);
// //     };
// //     fetchUser();
// //   }, [token]);

// //   const login = (newToken, userData) => {
// //     localStorage.setItem('token', newToken);
// //     setToken(newToken);
// //     setUser(userData);
// //   };

// //   const logout = () => {
// //     localStorage.removeItem('token');
// //     setToken(null);
// //     setUser(null);
// //     if (socket) {
// //       socket.disconnect();
// //       socket = null;
// //     }
// //   };

// //   const value = {
// //     user,
// //     token,
// //     login,
// //     logout,
// //     axiosInstance,
// //     socket
// //   };

// //   if (loading) {
// //     return (
// //       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-yellow-100">
// //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <AuthContext.Provider value={value}>
// //       <BrowserRouter>
// //         <div className="App">
// //           <Routes>
// //             <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
// //             <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            
// //             {/* <Route path="/dashboard" element={user ? (
// //               user.role === 'admin' ? <AdminDashboard /> : <UserDashboard />
// //             ) : <Navigate to="/login" />} /> */}
// //             <Route path="/dashboard" element={user ? (
// //               user.role === 'admin' ? <AdminDashboard /> :
// //               user.role === 'institution' ? <Navigate to="/institution-dashboard" /> :
// //               <UserDashboard />
// //             ) : <Navigate to="/login" />} />
// //             {/* <Route
// //               path="/profile"
// //               element={
// //                 user?.role === 'institution'
// //                   ? <InstitutionProfile />
// //                   : <Navigate to="/dashboard" />
// //               }
// //             /> */}
// //             {/* <Route
// //               path="/profile"
// //               element={
// //                 user?.role === 'institution' ? (
// //                   <InstitutionProfile />
// //                 ) : user?.role === 'nurse' || user?.role === 'caregiver' ? (
// //                   <UserProfile />
// //                 ) : (
// //                   <Navigate to="/dashboard" />
// //                 )
// //               }
// //             /> */}

// //             <Route
// //               path="/profile"
// //               element={
// //                 user?.role === 'institution' ? (
// //                   <InstitutionProfile />
// //                 ) : ['nurse', 'caregiver', 'admin'].includes(user?.role) ? (
// //                   <UserProfile />
// //                 ) : (
// //                   <Navigate to="/dashboard" />
// //                 )
// //               }
// //             />



            
// //             <Route path="/users" element={user?.role === 'admin' ? <Users /> : <Navigate to="/dashboard" />} />
// //             <Route
// //               path="/users/:id"
// //               element={user?.role === 'admin' ? <UserProfile /> : <Navigate to="/dashboard" />}
// //             />

// //             {/* <Route path="/institution-dashboard" element={<InstitutionDashboard />} /> */}
// //             <Route path="/institutions" element={user ? <Institutions /> : <Navigate to="/login" />} />
// //             <Route path="/reset-password" element={<ResetPassword />} />
// //             <Route path="/forgot-password" element={<ForgotPassword />} />
// //             <Route
// //               path="/institution-dashboard"
// //               element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />}
// //             />
// //             <Route
// //               path="/payrolls"
// //               element={user?.role === 'institution' ? <InstitutionPayrolls /> : <Navigate to="/dashboard" />}
// //             />
// //             <Route
// //               path="/tarifications"
// //               element={user?.role === 'institution' ? <Tarifictions /> : <Navigate to="/tarifications" />}
// //             />


// //             {/* <Route path="/prestations" element={user ? <Prestations /> : <Navigate to="/login" />} /> */}
// //             <Route path="/schedules" element={user ? <Schedules /> : <Navigate to="/login" />} />
// //             <Route path="/messages" element={user ? <Messages /> : <Navigate to="/login" />} />
// //             <Route
// //               path="/prestations"
// //               element={
// //                 user
// //                   ? user.role === 'admin' || user.role === 'établissement de santé'
// //                     ? <Prestations />
// //                     : <UserPrestations />
// //                   : <Navigate to="/login" />
// //               }
// //             />

// //             <Route path="/mes-prestations" element={<UserPrestations />} />

// //             {/* <Route path="/payslips" element={user ? <Payslips /> : <Navigate to="/login" />} /> */}
// //             <Route
// //               path="/user-payrolls"
// //               element={user?.role === 'caregiver' || user?.role === 'nurse' ? <UserPayrolls /> : <Navigate to="/dashboard" />}
// //             />
// //             {/* <Route path="/payrolls" element={<Payrolls />} /> */}
            
            
          
// //             <Route path="/teams" element={user ? <Teams /> : <Navigate to="/login" />} />
// //             <Route path="/exchanges" element={user ? <Exchanges /> : <Navigate to="/login" />} />
// //             <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
            
// //             <Route path="/" element={<Navigate to="/dashboard" />} />
// //           </Routes>
// //           <Toaster position="top-right" richColors />
// //         </div>
// //       </BrowserRouter>
// //     </AuthContext.Provider>
// //   );
// // }

// // export default App;





// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import axios from 'axios';
// import io from 'socket.io-client';
// import './App.css';
// import Login from './pages/Login';
// import ForgotPassword from './pages/ForgotPassword';
// import ResetPassword from './pages/ResetPassword';
// import Register from './pages/Register';
// import AdminDashboard from './pages/AdminDashboard';
// import UserDashboard from './pages/UserDashboard';
// import InstitutionDashboard from './pages/InstitutionDashboard';
// import InstitutionProfile from './pages/InstitutionProfile';
// import UserProfile from './pages/UserProfile';
// import Users from './pages/Users';
// import Institutions from './pages/Institutions';
// import Prestations from './pages/Prestations';
// import UserPrestations from './pages/UserPrestations';
// import Schedules from './pages/Schedules';
// import Messages from './pages/Messages';
// import Payslips from './pages/Payslips';
// import UserPayrolls from './pages/UserPayrolls';
// import Teams from './pages/Teams';
// import Exchanges from './pages/Exchanges';
// import Notifications from './pages/Notifications';
// import AdminNotifications from './pages/AdminNotifications';
// import { Toaster } from './components/ui/sonner';
// import { toast } from 'sonner';
// import Payrolls from './pages/Payrolls';
// import InstitutionPayrolls from './pages/InstitutionPayrolls';
// import Tarifications from './pages/Tarifications';
// import Soins from './pages/Soins';
// import PrestationChef from './pages/Prestations_chef';


// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

// // Auth Context
// const AuthContext = createContext(null);

// export const useAuth = () => useContext(AuthContext);

// // Axios instance
// const axiosInstance = axios.create({
//   baseURL: API,
// });

// // Socket.io instance
// let socket = null;

// function App() {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [token, setToken] = useState(localStorage.getItem('token'));

//   // Setup axios interceptor
//   useEffect(() => {
//     if (token) {
//       axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
//     } else {
//       delete axiosInstance.defaults.headers.common['Authorization'];
//     }
//   }, [token]);

//   // Fetch current user
//   useEffect(() => {
//     const fetchUser = async () => {
//       if (token) {
//         try {
//           const response = await axiosInstance.get('/auth/me');
//           setUser(response.data);
          
//           // Connect to socket.io
//           if (!socket) {
//             socket = io(BACKEND_URL);
//             socket.emit('join', { user_id: response.data.id });
            
//             // Listen for notifications
//             socket.on('notification', (data) => {
//               toast.info(data.message);
//             });
            
//             socket.on('new_message', (data) => {
//               toast.info('New message received');
//             });
//           }
//         } catch (error) {
//           console.error('Failed to fetch user', error);
//           localStorage.removeItem('token');
//           setToken(null);
//         }
//       }
//       setLoading(false);
//     };
//     fetchUser();
//   }, [token]);

//   const login = (newToken, userData) => {
//     localStorage.setItem('token', newToken);
//     setToken(newToken);
//     setUser(userData);
//   };

//   const logout = () => {
//     localStorage.removeItem('token');
//     setToken(null);
//     setUser(null);
//     if (socket) {
//       socket.disconnect();
//       socket = null;
//     }
//   };

//   const value = {
//     user,
//     token,
//     login,
//     logout,
//     axiosInstance,
//     socket
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-yellow-100">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
//       </div>
//     );
//   }

//   return (
//     <AuthContext.Provider value={value}>
//       <BrowserRouter>
//         <div className="App">
//           <Routes>
//             <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
//             <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            
//             {/* <Route path="/dashboard" element={user ? (
//               user.role === 'admin' ? <AdminDashboard /> : <UserDashboard />
//             ) : <Navigate to="/login" />} /> */}
//             <Route path="/dashboard" element={user ? (
//               user.role === 'admin' ? <AdminDashboard /> :
//               user.role === 'institution' ? <Navigate to="/institution-dashboard" /> :
//               <UserDashboard />
//             ) : <Navigate to="/login" />} />
//             {/* <Route
//               path="/profile"
//               element={
//                 user?.role === 'institution'
//                   ? <InstitutionProfile />
//                   : <Navigate to="/dashboard" />
//               }
//             /> */}
//             {/* <Route
//               path="/profile"
//               element={
//                 user?.role === 'institution' ? (
//                   <InstitutionProfile />
//                 ) : user?.role === 'nurse' || user?.role === 'caregiver' ? (
//                   <UserProfile />
//                 ) : (
//                   <Navigate to="/dashboard" />
//                 )
//               }
//             /> */}

//             <Route
//               path="/profile"
//               element={
//                 user?.role === 'institution' ? (
//                   <InstitutionProfile />
//                 ) : ['nurse', 'caregiver', 'admin'].includes(user?.role) ? (
//                   <UserProfile />
//                 ) : (
//                   <Navigate to="/dashboard" />
//                 )
//               }
//             />



            
//             <Route path="/users" element={user?.role === 'admin' ? <Users /> : <Navigate to="/dashboard" />} />
//             <Route
//               path="/users/:id"
//               element={user?.role === 'admin' ? <UserProfile /> : <Navigate to="/dashboard" />}
//             />

//             {/* <Route path="/institution-dashboard" element={<InstitutionDashboard />} /> */}
//             <Route path="/institutions" element={user ? <Institutions /> : <Navigate to="/login" />} />
//             <Route path="/reset-password" element={<ResetPassword />} />
//             <Route path="/forgot-password" element={<ForgotPassword />} />
//             {/* SUPPRIME la route /institution-dashboard DUPLIQUÉE et garde UNIQUEMENT : */}
//             {/* <Route path="/institution-dashboard" element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />}>
//               <Route path="tarifications" element={<Tarifictions />} />
//             </Route> */}
//             <Route
//               path="/institution-dashboard"
//               element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />}
//             />
//             <Route
//               path="/institution-dashboard/tarifications"
//               element={user?.role === 'institution' ? <Tarifications /> : <Navigate to="/dashboard" />}
//             />
//             <Route
//               path="/payrolls"
//               element={user?.role === 'institution' ? <InstitutionPayrolls /> : <Navigate to="/dashboard" />}
//             />
//             {/* <Route
//               path="/tarifications"
//               element={user?.role === 'institution' ? <Tarifictions /> : <Navigate to="/tarifications" />}
//             /> */}
//             {/* Route pour les tarifications d'une institution spécifique */}
//             {/* <Route
//               path="/institutions/:institutionId/tarifications"
//               element={user ? <Tarifictions /> : <Navigate to="/login" />}
//             /> */}


//             {/* <Route path="/prestations" element={user ? <Prestations /> : <Navigate to="/login" />} /> */}
//             <Route path="/schedules" element={user ? <Schedules /> : <Navigate to="/login" />} />
//             <Route path="/messages" element={user ? <Messages /> : <Navigate to="/login" />} />
//             {/* <Route
//               path="/prestations"
//               element={
//                 user
//                   ? user.role === 'admin' || user.role === 'établissement de santé'
//                     ? <Prestations />
//                     : <UserPrestations />
//                   : <Navigate to="/login" />
//               }
//             /> */}
//             <Route
//               path="/prestations"
//               element={
//                 user
//                   ? user.role === 'admin' || user.role === 'établissement de santé'
//                     ? <Prestations />
//                     : <UserPrestations />
//                   : <Navigate to="/login" />
//               }
//             />

//             <Route
//               path="/prestations-chef"
//               element={
//                 user?.appli_role === 'chef'
//                   ? <PrestationChef />
//                   : <Navigate to="/dashboard" />
//               }
//             />

//             <Route path="/mes-prestations" element={<UserPrestations />} />

//             {/* <Route path="/payslips" element={user ? <Payslips /> : <Navigate to="/login" />} /> */}
//             <Route
//               path="/user-payrolls"
//               element={user?.role === 'caregiver' || user?.role === 'nurse' ? <UserPayrolls /> : <Navigate to="/dashboard" />}
//             />
//             {/* <Route path="/payrolls" element={<Payrolls />} /> */}
            
            
          
//             <Route path="/teams" element={user ? <Teams /> : <Navigate to="/login" />} />
//             <Route path="/exchanges" element={user ? <Exchanges /> : <Navigate to="/login" />} />
//             <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
//             <Route
//               path="/soins"
//               element={
//                 user
//                   ? (user.role === 'admin' || user.role === 'coordinateur'
//                       ? <Soins />
//                       : <Soins /> // laisse passer mais la page bloque elle-même
//                     )
//                   : <Navigate to="/login" />
//               }
//             />
            
//             <Route path="/" element={<Navigate to="/dashboard" />} />
//           </Routes>
//           <Toaster position="top-right" richColors />
//         </div>
//       </BrowserRouter>
//     </AuthContext.Provider>
//   );
// }

// export default App;



import React, { createContext, useContext, useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import io from 'socket.io-client';
import './App.css';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import InstitutionDashboard from './pages/InstitutionDashboard';
import InstitutionProfile from './pages/InstitutionProfile';
import UserProfile from './pages/UserProfile';
import Users from './pages/Users';
import Institutions from './pages/Institutions';
import Prestations from './pages/Prestations';
import UserPrestations from './pages/UserPrestations';
import Schedules from './pages/Schedules';
import Messages from './pages/Messages';
import Payslips from './pages/Payslips';
import UserPayrolls from './pages/UserPayrolls';
import Teams from './pages/Teams';
import Exchanges from './pages/Exchanges';
import Notifications from './pages/Notifications';
import AdminNotifications from './pages/AdminNotifications';
import { Toaster } from './components/ui/sonner';
import { toast } from 'sonner';
import Payrolls from './pages/Payrolls';
import InstitutionPayrolls from './pages/InstitutionPayrolls';
import Tarifications from './pages/Tarifications';
import Soins from './pages/Soins';
import PrestationAdmin from './pages/Prestations_admin';
import MyExchangeInbox from './pages/MyExchangeInbox';
import AdminExchange from './pages/AdminExchange';
import DomicilePayrolls from './pages/DomicilePayrolls';
import DashboardAdmin from './pages/DashboardAdmin';
import MaTournee from './pages/MaTournee';
import PatientCare from './pages/PatientCare';
import TitulaireDashboard from './pages/TitulaireDashboard';
import MesRemplacements from './pages/MesRemplacements';
import NouvelleDemandeRemplacement from './pages/NouvelleDemandeRemplacement';
import AdminRemplacementsDomicile from './pages/AdminRemplacementsDomicile';
import Payments from "./pages/Payments";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth Context
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

// Axios instance
const axiosInstance = axios.create({
  baseURL: API,
});

// Socket.io instance
let socket = null;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  // Setup axios interceptor
  useEffect(() => {
    if (token) {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete axiosInstance.defaults.headers.common['Authorization'];
    }
  }, [token]);

  // Fetch current user
  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        try {
          const response = await axiosInstance.get('/auth/me');
          setUser(response.data);
          
          // Connect to socket.io
          if (!socket) {
            socket = io(BACKEND_URL);
            socket.emit('join', { user_id: response.data.id });
            
            // Listen for notifications
            socket.on('notification', (data) => {
              toast.info(data.message);
            });
            
            socket.on('new_message', (data) => {
              toast.info('New message received');
            });
          }
        } catch (error) {
          console.error('Failed to fetch user', error);
          localStorage.removeItem('token');
          setToken(null);
        }
      }
      setLoading(false);
    };
    fetchUser();
  }, [token]);

  const login = (newToken, userData) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  };

  const value = {
    user,
    token,
    login,
    logout,
    axiosInstance,
    socket
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-amber-50 to-yellow-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Auth routes */}
            <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" />} />
            <Route path="/register" element={!user ? <Register /> : <Navigate to="/dashboard" />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Dashboard */}
            {/* <Route path="/dashboard" element={user ? (
              user.role === 'admin' ? <AdminDashboard /> :
              user.role === 'institution' ? <Navigate to="/institution-dashboard" /> :
              <UserDashboard />
            ) : <Navigate to="/login" />} /> */}
            *<Route
              path="/dashboard"
              element={
                user ? (
                  user.role === 'admin' ? (
                    <AdminDashboard />
                  ) : user.role === 'institution' ? (
                    <Navigate to="/institution-dashboard" />
                  ) : user.role === 'titulaire_domicile' ? (
                    <Navigate to="/titulaire-dashboard" />
                  ) : (
                    <UserDashboard />
                  )
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route path="/admin/payments" element={<Payments />} />

            <Route
              path="/titulaire-dashboard"
              element={
                user?.role === 'titulaire_domicile'
                  ? <TitulaireDashboard />
                  : <Navigate to="/dashboard" />
              }
            />

            <Route
              path="/remplacements-domicile"
              element={
                user?.role === 'titulaire_domicile'
                  ? <MesRemplacements />
                  : <Navigate to="/dashboard" />
              }
            />

            <Route
              path="/remplacements-domicile/nouveau"
              element={
                user?.role === 'titulaire_domicile'
                  ? <NouvelleDemandeRemplacement />
                  : <Navigate to="/dashboard" />
              }
            />

            <Route
              path="/remplacements-domicile-admin"
              element={
                user?.role === 'admin' ||
                user?.appli_role === 'chef' ||
                user?.care_role === 'coordinateur'
                  ? <AdminRemplacementsDomicile />
                  : <Navigate to="/dashboard" />
              }
            />

            {/* Profiles */}
            <Route path="/profile" element={
              user?.role === 'institution' ? (
                <InstitutionProfile />
              ) : ['nurse', 'caregiver', 'admin', 'titulaire_domicile' ].includes(user?.role) ? (
                <UserProfile />
              ) : (
                <Navigate to="/dashboard" />
              )
            } />
            <Route path="/users/:id" element={user?.role === 'admin' ? <UserProfile /> : <Navigate to="/dashboard" />} />

            {/* Admin routes */}
            <Route path="/users" element={user?.role === 'admin' ? <Users /> : <Navigate to="/dashboard" />} />
            <Route path="/admin-notifications" element={user?.role === 'admin' ? <AdminNotifications /> : <Navigate to="/dashboard" />} /> 
            <Route path="/admin-echanges" element={user?.role === 'admin' ? <AdminExchange /> : <Navigate to="/dashboard" />} /> 
            <Route
              path="/direction"
              element={
                user?.role === 'admin'
                  ? <DashboardAdmin />
                  : <Navigate to="/dashboard" />
              }
            />

            {/* Institution routes */}
            <Route path="/institution-dashboard" element={user?.role === 'institution' ? <InstitutionDashboard /> : <Navigate to="/dashboard" />} />
            <Route path="/institution-dashboard/tarifications" element={user?.role === 'institution' ? <Tarifications /> : <Navigate to="/dashboard" />} />
            <Route path="/payrolls" element={user?.role === 'institution' ? <InstitutionPayrolls /> : <Navigate to="/dashboard" />} />

            {/* Common routes */}
            <Route path="/institutions" element={user ? <Institutions /> : <Navigate to="/login" />} />
            <Route path="/prestations" element={
              user ? (
                user.role === 'admin' || user.role === 'établissement de santé' ? <Prestations /> : <UserPrestations />
              ) : <Navigate to="/login" />
            } />
            <Route path="/prestations-admin" element={
              user?.appli_role === 'chef' ? <PrestationAdmin /> : <Navigate to="/dashboard" />
            } />
            <Route path="/mes-prestations" element={<UserPrestations />} />
            <Route path="/schedules" element={user ? <Schedules /> : <Navigate to="/login" />} />
            <Route path="/messages" element={user ? <Messages /> : <Navigate to="/login" />} />
            <Route path="/teams" element={user ? <Teams /> : <Navigate to="/login" />} />
            <Route path="/exchanges" element={user ? <Exchanges /> : <Navigate to="/login" />} />
            <Route path="/notifications" element={user ? <Notifications /> : <Navigate to="/login" />} />
            <Route path="/user-payrolls" element={user?.role === 'caregiver' || user?.role === 'nurse' ? <UserPayrolls /> : <Navigate to="/dashboard" />} />
            {/* <Route path="/soins" element={
              user ? (
                user.role === 'admin' || user.appli_role === 'chef' || user.care_role === 'coordinateur' ? <Soins /> : <Navigate to="/dashboard" />
              ) : <Navigate to="/login" />
            } /> */}
            <Route
              path="/domicile-payrolls/:caregiverId"
              element={<DomicilePayrolls />}
            />
            <Route path="/mes-echanges" element={user?.role === 'caregiver' || user?.role === 'nurse' ? <MyExchangeInbox /> : <Navigate to="/dashboard" />} />
            <Route path="/soins" element={
              user ? <Soins /> : <Navigate to="/login" />
            } />

            {/* <Route
              path="/ma-tournee"
              element={
                user ? <MaTournee /> : <Navigate to="/login" />
              }
            /> */}

            <Route
              path="/soins/patient/:patientId"
              element={
                user ? <PatientCare /> : <Navigate to="/login" />
              }
            />

            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;